import React from 'react';
import { healthFirst } from 'images';

const FirstAnswer = () => (
  <img
    src={healthFirst}
    style={{ width: '100%', heigth: '100%' }}
    alt="Water Travels"
  />
);

export default FirstAnswer;
